import { useAppDispatch } from "@store";
import { openDialog } from "@store/dialogs";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useGetAccountQuery } from "@/shared/services";
import AccountIsOnHoldDialog from "../components/account-is-on-hold-dialog";
import { EXCLUDED_PATHS } from "../constants";

export const useAccountOnHoldDialog = () => {
  const { data: account } = useGetAccountQuery();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const showDialog = useMemo(() => {
    if (!account) return false;
    const { plan, subscriptionStatus } = account;
    return (
      plan === "paid" &&
      subscriptionStatus === "paused" &&
      !EXCLUDED_PATHS.test(location.pathname)
    );
  }, [account, location.pathname]);

  useEffect(() => {
    if (!showDialog) return;
    dispatch(
      openDialog({
        id: "account-is-on-hold",
        content: AccountIsOnHoldDialog,
      }),
    );
  }, [showDialog, dispatch]);
};
